import { EmptyState, buttonClasses } from '@nexo/ui';
import { Compass } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex h-full items-center justify-center">
      <EmptyState
        icon={<Compass className="size-8" />}
        title={t('Página no encontrada')}
        description={t('El enlace no existe o ya no tienes acceso.')}
        action={
          <Link to="/app" className={buttonClasses()}>
            {t('Volver a la app')}
          </Link>
        }
      />
    </div>
  );
}
